export default __webpack_public_path__ + "img/11802d1e5fcad49b9bdc2211e46c5cea.svg";